/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateModifyGroupDto interface.
 */
export function instanceOfCreateModifyGroupDto(value) {
    return true;
}
export function CreateModifyGroupDtoFromJSON(json) {
    return CreateModifyGroupDtoFromJSONTyped(json, false);
}
export function CreateModifyGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'ownerEmail': json['ownerEmail'] == null ? undefined : json['ownerEmail'],
    };
}
export function CreateModifyGroupDtoToJSON(json) {
    return CreateModifyGroupDtoToJSONTyped(json, false);
}
export function CreateModifyGroupDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'ownerEmail': value['ownerEmail'],
    };
}
